module.exports = require('./helpers/bundle-url').getBundleURL('2Xr4i') + "logo.c51670a8.svg";